import UnstyledAccordion from '@mui/material/Accordion'
import UnstyledAccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Grid from '@mui/material/Grid'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: flex-end;
`

const Accordion = styled(UnstyledAccordion)`
  &#account_accordion {
    border-radius: 0;
    margin: 0;
  }
  box-shadow: unset;
  width: 100%;
  z-index: ${props => props.theme.zIndex.fixed};
`

const AccordionDetails = styled(UnstyledAccordionDetails)`
  ${props => {
    return props.direction === 'up'
      ? 'border-bottom: 3px solid #68504c; background-color: white;'
      : 'border-top: 3px solid #68504c;'
  }}

  padding: 4px;
`

export default ({ expanded, children, className, direction = 'down' }) => {
  return (
    <Accordion
      id='account_accordion'
      className={className}
      expanded={expanded}
      square={true}
    >
      <AccordionSummary sx={{ display: 'none' }}></AccordionSummary>
      <AccordionDetails direction={direction}>
        <Wrapper>
          <Grid container columnSpacing={0.5} rowSpacing={0.5}>
            {children}
          </Grid>
        </Wrapper>
      </AccordionDetails>
    </Accordion>
  )
}
